import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { updateEvidence, UPDATE_EVIDENCE} from "../../actions/student.action"

function* handleUpdateEvidence(action) {
  try {
    const { data : resData} = yield call(studentAPI.updateEvidence, action.payload);
    //extract the data here     
    yield put(updateEvidence.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(updateEvidence.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* updateEvidenceSaga() {
  yield takeLatest(UPDATE_EVIDENCE.REQUEST, handleUpdateEvidence);
}

export default updateEvidenceSaga;
